import Highcharts from 'highcharts/highstock'
import getJSON from '~/js/helpers/xhr'
import StockChartCommon from '~/js/modules/stock-chart-common'
import moment from 'moment/dist/moment'

export default class StockChart extends StockChartCommon {

  init() {

    Highcharts.setOptions({
      time: {
        timezone: 'Europe/Moscow'
      },
      lang: {
        loading: 'Загрузка...',
        months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
        weekdays: ['Воскресенье', 'Понедельник', 'Вторник', 'Среда', 'Четверг', 'Пятница', 'Суббота'],
        shortMonths: ['Янв', 'Фев', 'Март', 'Апр', 'Май', 'Июнь', 'Июль', 'Авг', 'Сент', 'Окт', 'Нояб', 'Дек'],
        exportButtonTitle: "Экспорт",
        printButtonTitle: "Печать",
        rangeSelectorFrom: 'период c',
        rangeSelectorTo: "по",
        rangeSelectorZoom: "",
        downloadPNG: 'Скачать PNG',
        downloadJPEG: 'Скачать JPEG',
        downloadPDF: 'Скачать PDF',
        downloadSVG: 'Скачать SVG',
        printChart: 'Напечатать график'
      },
    });

    const ChartBlock = document.querySelector(`.js-premium-discount-chart`)
    const ChartWrap = document.querySelectorAll(`.js-stock-chart-wrap`)
    const now = moment().unix() * 1000
    const month = moment().month()
    const currentYear = moment().year()
    const prevYear = currentYear - 1
    const firstDayOfCurrentYear = moment([currentYear]).unix() * 1000 // + 21600000
    let firstDayOfPrevYear = moment([prevYear]).unix() * 1000 // + 21600000
    const Difference_In_Days_PYTD = Math.floor( ( now - firstDayOfPrevYear ) / ( 1000 * 3600 * 24 ) ) - 1
    const startOfPrevQ = moment().subtract(1, 'quarter').startOf('quarter').unix() * 1000 + 21600000
    const endOfPrevQ = moment().subtract(1, 'quarter').endOf('quarter').unix() * 1000 // + 21600000
    const Difference_In_Days_PQ = Math.floor( ( endOfPrevQ - startOfPrevQ ) / ( 1000 * 3600 * 24 ) )
    /* смещение на 6 часов из-за часовых поясов */
    if ( month <=3 ) {
      document.querySelectorAll('.js-q2-cell').forEach((q)=>{
        q.style.display = 'none'
      })
      document.querySelectorAll('.js-q3-cell').forEach((q)=>{
        q.style.display = 'none'
      })
      if (document.querySelector('.js-table-growth')) {
        document.querySelector('.js-table-growth').style = 'grid-template-columns: 40% 30% 30%'
      }
    } else if ( month <=5 ) {
      document.querySelectorAll('.js-q3-cell').forEach((q)=>{
        q.style.display = 'none'
      })
      if (document.querySelector('.js-table-growth')) {
        document.querySelector('.js-table-growth').style = 'grid-template-columns: 25% 25% 25% 25%'
      }
    }

    getJSON(`assets/components/dohod/connectorweb.php?action=PremiumDiscount/get&resId=${this._resId}`).then((data) => {

      if (document.querySelector('.year-premium')) {
        document.querySelector('.year-premium').innerText = data.yearItems.premium
      }
      if (document.querySelector('.year-nav')) {
        document.querySelector('.year-nav').innerText = data.yearItems.nav
      }
      if (document.querySelector('.year-discount')) {
        document.querySelector('.year-discount').innerText = data.yearItems.discount
      }
      if ( month > 2 ) {
        if (document.querySelector('.q1-premium')) {
          document.querySelector('.q1-premium').innerText = data.q1Items.premium
        }
        if (document.querySelector('.q1-nav')) {
          document.querySelector('.q1-nav').innerText = data.q1Items.nav
        }
        if (document.querySelector('.q1-discount')) {
          document.querySelector('.q1-discount').innerText = data.q1Items.discount
        }
      }
      if ( month > 5 ) {
        if (document.querySelector('.q2-premium')) {
          document.querySelector('.q2-premium').innerText = data.q2Items.premium
        }
        if (document.querySelector('.q2-nav')) {
          document.querySelector('.q2-nav').innerText = data.q2Items.nav
        }
        if (document.querySelector('.q2-discount')) {
          document.querySelector('.q2-discount').innerText = data.q2Items.discount
        }
      }
      if ( month > 8 ) {
        if (document.querySelector('.q3-premium')) {
          document.querySelector('.q3-premium').innerText = data.q3Items.premium
        }
        if (document.querySelector('.q3-nav')) {
          document.querySelector('.q3-nav').innerText = data.q3Items.nav
        }
        if (document.querySelector('.q3-discount')) {
          document.querySelector('.q3-discount').innerText = data.q3Items.discount
        }
      }

      if (data.items.length) {

        let Difference_In_Days_PY
        if ( data.items[0][0] > firstDayOfPrevYear) {
          firstDayOfPrevYear = data.items[0][0]
          Difference_In_Days_PY = Math.floor( ( firstDayOfCurrentYear - firstDayOfPrevYear ) / ( 1000 * 3600 * 24 ) )
        } else {
          Difference_In_Days_PY = Math.floor( ( firstDayOfCurrentYear - firstDayOfPrevYear ) / ( 1000 * 3600 * 24 ) ) - 1
        }

        const pdchart = Highcharts.stockChart(ChartBlock, {
          series: [{
            name: 'Дисконт/Премия',
            data: data.items,
            color: '#0BBA7C',
            pointInterval: 24 * 3600 * 1000
          }],
          // кнопки выбора периода
          rangeSelector: {
            allButtonsEnabled: true,
            verticalAlign: 'top',
            buttons: [{
              type: 'day',
              count: Difference_In_Days_PYTD,
              text: 'Previous Year to Date',
              events: {
                click: ()=> {
                  const xAxis = pdchart.xAxis[0]
                  let min = firstDayOfPrevYear
                  if (xAxis.dataMin > min) {
                    min = xAxis.dataMin
                  }
                  xAxis.setExtremes(min, now, true)
                  return true
                }
              }
            }, {
              type: 'day',
              count:Difference_In_Days_PY,
              text: 'Previous Year',
              events: {
                click: function(e) {
                  const xAxis = pdchart.xAxis[0]
                  let min = firstDayOfPrevYear
                  if (xAxis.dataMin > min) {
                    min = xAxis.dataMin
                  }
                  xAxis.setExtremes(min, firstDayOfCurrentYear)
                  return true
                }
              }
            }, {
              type: 'day',
              count: Difference_In_Days_PQ,
              text: 'Previous Quarter',
              events: {
                click: function(e) {
                  const xAxis = pdchart.xAxis[0]
                  xAxis.setExtremes(startOfPrevQ, endOfPrevQ, true, true)
                  return true
                }
              }
            }, {
              type: 'all',
              text: 'All',
            }],
            buttonTheme: {
              width: 'auto'
            },
            floating: true,
            selected: 3,
            dropdown: 'never',
          },
          responsive: {
            rules: [{
              condition: {
                maxWidth: 450
              },
              chartOptions: {
                rangeSelector: {
                  buttonTheme: {
                    padding: 4,
                  },
                  inputPosition: {
                    y: -40,
                  },
                  buttonPosition: {
                    x: -25,
                    y: -40,
                    align: 'left'
                  },
                }
              }
            },
            ],
          },
          // скрыть навигатор, скролбар и ссылку highcharts.com
          navigator: { enabled: false },
          scrollbar: { enabled: false },
          credits: { enabled: false },
          tooltip: {
            headerFormat: "",
            xDateFormat: "%d.%m.%Y",
            pointFormatter: function () {
              let t = this.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "),
                e = new Date(this.x).toLocaleDateString("ru-RU", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric"
                });
              return e = e[0].toUpperCase() + e.slice(1), "<b>".concat(e,'</b><br/><span style="color:').concat(this.series.color, '">').concat(this.series.name, ": <b>").concat(t, "</b></span><br/>")
            },
            split: !0
          },
          xAxis: {
            labels: {
              format: '{value:%e.%m.%Y}',
            },
            type: 'datetime'
          },
          yAxis: {
            opposite: false,
            title: {
              text: '%',
              align: 'high',
              y: 30
            },
            labels: {
              allowOverlap: true,
            }
          },
        })
      }

    })

    async function checkResource(url) {
      try {
        const response = await fetch(url, { method: 'HEAD', mode: 'no-cors' });

        if (response.ok) {
          console.log(`Ресурс доступен: ${url}`);
        } else {
          console.log(`Ресурс заблокирован или недоступен: ${url}`);
          if (ChartWrap) {
            ChartWrap.forEach((cw) => {
              cw.classList.add('charts__block-error-loading')
              cw.innerHTML = `<img src="/assets/images/error-data.gif">Ошибка загрузки<br>Пожалуйста, обновите страницу`
            })
          }
        }
      } catch (error) {
        console.log(`Ошибка при проверке ресурса: ${error.message}`);
        if (ChartWrap) {
          ChartWrap.forEach((cw) => {
            cw.classList.add('charts__block-error-loading')
            cw.innerHTML = `<img src="/assets/images/error-data.gif">Ошибка загрузки<br>Пожалуйста, обновите страницу`
          })
        }
      }
    }

    let chartUrl = ``
    if (this._type) {
      chartUrl = `assets/components/dohod/connectorweb.php?type=${this._type}&tab=${this._tab}&action=${this._action}&resId=${this._resId}`
    } else {
      chartUrl = `assets/components/dohod/connectorweb.php?tab=${this._tab}&action=${this._action}&resId=${this._resId}`
    }
// Проверка доступности
    checkResource(chartUrl)

    getJSON(chartUrl).then((data) => {

      this._options = this._originalOptions;
      this._options.series = [];
      var keys = Object.keys(data.items);

      if (data && data.items[keys[0]].length > 1) {
        if (ChartWrap) {
          ChartWrap.forEach((cw) => {
            let waitBlock = cw.querySelector('.charts__block-waiting')
            if (waitBlock) {
              waitBlock.remove()
            }
          })
        }
        this._setOffsetMins(data.items[keys[0]]);
      } else {
        if (ChartWrap) {
          ChartWrap.forEach((cw) => {
            cw.classList.add('charts__block-error-loading')
            cw.innerHTML = `<img src="/assets/images/error-data.gif">Ошибка загрузки<br>Пожалуйста, обновите страницу`
          })
        }
      }

      let i = 0;
      let textLegend = '';
      if (this._chartParam) {
        for (let chart of this._chartParam.charts) {
          if (chart) {
          if (this._resId == 1153) {
            this._options.series.push({
              name: chart.cod,
              color: chart.color,
              data: data.items[chart.id],
            });
          } else {
            this._options.series.push({
              name: chart.cod,
              color: chart.color,
              data: data.items[chart.cod],
            });
          }
          if(this._legend) {
            let checked = chart.visible ? 'checked' : ''
            textLegend += `<label class='charts__block-label t-small'><input class='js-stock-chart-legend-item' type='checkbox' ${checked}>&nbsp;${chart.name}</label>`;
          }
          i++;
          }
        }
      }
      this._legend.innerHTML = textLegend;
      this._legendItems = this._element.closest('.charts__block').querySelectorAll(`.js-stock-chart-legend-item`);

      switch (this._tab) {
        case 'prices':
          if (this._options.yAxis.length) {
            this._options.yAxis.forEach(function (y) {
              y.labels.formatter = function () {
                return this.value;
              };
            });
          }
          break;
        case 'profitability':
          this._options.plotOptions.series.compare = 'percent';
          this._options.plotOptions.series.showInNavigator = true;
          if (this._options.yAxis.length) {
            this._options.yAxis.forEach(function (y) {
              y.labels.formatter = function () {
                return this.value +   '%';
              };
            });
          }
          break;
        default:
          if (this._options.yAxis.length) {
            this._options.yAxis.forEach(function (y) {
              y.labels.formatter = function () {
                return this.value;
              };
            });
          }

      }

      let _this = this;

      this._options.tooltip.pointFormatter = function () {
        const value = this.y.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        const beginItem = this.series.cropStart ? this.series.yData[this.series.cropStart+1] : this.series.yData[this.series.cropStart];
        const diff = (this.y / beginItem * 100 - 100).toFixed(2);
        let dateResult = '';
        let date = new Date(this.x).toLocaleDateString('ru-RU', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
        if((this.index+1) == this.series.yData.length) {
          let dateTime = new Date(this.x).toLocaleDateString('ru-RU', {weekday: 'long', year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric'});
          dateResult =  dateTime[0].toUpperCase() + dateTime.slice(1);
        }
        else {
          dateResult = date[0].toUpperCase() + date.slice(1);
        }
        return `
            <b>${dateResult}</b><br/>
            <span style="color:${this.series.color}">${this.series.name}: <b>${value}</b></span><br/>
            <span style="color:${this.series.color}">Прирост: </span><b>${diff}%</b>`;
      }

      this._instance = Highcharts.stockChart(this._chart, this._options);

      if (this._legendItems.length) {
        let chart = this._instance;
        this._legendItems.forEach((elem, i) => {
          chart.series[i].update({
            visible: elem.checked ? true : false,
          });
          elem.onchange = function () {
            chart.series[i].update({
              showInLegend: chart.series[i].legendItem ? false : true,
            });
            chart.series[i].setVisible();
          };
        });
      }

    });

  }
}
